import type { FC } from "react"

interface Props {
  className?: string
}

const PlayTriangle: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 10.268a2 2 0 0 1 0 3.464l-12 6.928A2 2 0 0 1 5.5 18.928V5.072a2 2 0 0 1 3-1.732l12 6.928Z"
        fill="white"
      />
    </svg>
  )
}

export default PlayTriangle
